import { type ReactElement } from 'react'
import { Combobox } from '@mantine/core'
import { isDefined, isEmpty, type TeamData, type TeamId } from '@terros/common'
import { PrefetchedTeamInfo } from 'app/components/entityInfo'
import { SelectableOption } from '../SelectableOption'

type GroupedTeamOption = {
  group: string
  items: Array<{ value: string; label: string }>
}

type TeamComboboxOptionsProps = {
  groupedTeamOptions: GroupedTeamOption[]
  availableTeams: TeamData[]
  selectedValue?: TeamId[]
}

export const useTeamComboboxOptions = ({
  groupedTeamOptions,
  availableTeams,
  selectedValue,
}: TeamComboboxOptionsProps): ReactElement[] => {
  const isSelected = (teamId: TeamId): boolean => Boolean(selectedValue?.includes(teamId))

  return groupedTeamOptions
    .map((group) => {
      if (isEmpty(group.items)) return
      return (
        <Combobox.Group key={group.group} label={group.group}>
          <div className='flex flex-col gap-md'>
            {group.items
              .map((item) => {
                const team = availableTeams.find((team) => team.teamId === item.value)
                if (!team) return
                const selected = isSelected(team.teamId)

                return (
                  <SelectableOption key={item.value} value={item.value} selected={selected}>
                    <PrefetchedTeamInfo
                      linked={false}
                      team={team}
                      textProps={{ size: 'sm', lineClamp: undefined, className: 'flex-1' }}
                    />
                  </SelectableOption>
                )
              })
              .filter(isDefined)}
          </div>
        </Combobox.Group>
      )
    })
    .filter(isDefined)
}
